export default __webpack_public_path__ + "static/media/coupons_empty.51de404a.svg";